import { LocalShipping, ThumbDown, ThumbUp } from "@material-ui/icons";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import CreatedByField from "../../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { Chip } from "@material-ui/core";
import * as React from "react";
import { formatDate } from "../../../../Helper/MomentHelper";

const RequestRedeliveryStatusChip = ({ requestRedelivery }) => {
  let icon, text;

  if (requestRedelivery.status === RequestStatus.RequestRedeliveryOffered) {
    icon = <LocalShipping />;
    text = RequestStatus[RequestStatus.RequestRedeliveryOffered];
  } else if (requestRedelivery.status === RequestStatus.RequestRedeliveryAccepted) {
    icon = <ThumbUp />;
    text = [
      RequestStatus[RequestStatus.RequestRedeliveryAccepted],
      " by ",
      <CreatedByField record={requestRedelivery} link={false} source="updatedBy" />,
      " ",
      formatDate(requestRedelivery.updatedDate),
    ];
  } else if (requestRedelivery.status === RequestStatus.RequestRedeliveryRejected) {
    icon = <ThumbDown />;
    text = [
      RequestStatus[RequestStatus.RequestRedeliveryRejected],
      " by ",
      <CreatedByField record={requestRedelivery} link={false} source="updatedBy" />,
      " ",
      formatDate(requestRedelivery.updatedDate),
    ];
  }
  return <Chip key={999999} color="primary" variant="outlined" label={text} icon={icon} />;
};

export default RequestRedeliveryStatusChip;
